export default {"src":"/_next/static/media/loader1-1.79e50a51.gif","height":360,"width":360,"blurWidth":0,"blurHeight":0};